import InputField from './InputField'
import { withInputField } from './withInputField'

const ConnectedInputField = withInputField(InputField)

export { ConnectedInputField as InputField }
